// src/pages/master/Pedidos.jsx
import { useEffect, useState } from 'react';
import { AdminSidebar, Icon, StatusBadge, Pagination, formatBRL, formatDate } from '../../components/shared';
import api from '../../services/api';
import toast from 'react-hot-toast';

export default function MasterPedidos() {
  const [pedidos, setPedidos] = useState([]);
  const [total, setTotal]     = useState(0);
  const [page, setPage]       = useState(1);
  const [loading, setLoad]    = useState(true);
  const [status, setStatus]   = useState('');

  useEffect(() => {
    setLoad(true);
    api.get('/pedidos', { params: { page, limit: 20, status } })
      .then(r => { setPedidos(r.data.dados); setTotal(r.data.total); })
      .catch(() => toast.error('Erro ao carregar'))
      .finally(() => setLoad(false));
  }, [page, status]);

  return (
    <div className="admin-layout">
      <AdminSidebar perfil="master" />
      <div className="main-content">
        <div className="topbar"><h1>Pedidos — Visão Global</h1></div>
        <div className="page-content">
          <div className="table-card">
            <div className="table-header">
              <select className="form-control" value={status}
                onChange={e => { setStatus(e.target.value); setPage(1); }} style={{ width: 160 }}>
                <option value="">Todos os status</option>
                {['pendente','aceito','em_rota','entregue','retirado','cancelado'].map(s => (
                  <option key={s} value={s}>{s}</option>
                ))}
              </select>
              <span style={{ fontSize: '.8rem', color: 'var(--text-muted)' }}>{total} pedido(s)</span>
            </div>
            {loading ? <div className="loading-center"><div className="spinner" /></div> : (
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr><th>Empresa</th><th>Cliente</th><th>Tipo</th><th>Total</th><th>Status</th><th>Data</th></tr>
                  </thead>
                  <tbody>
                    {pedidos.map(p => (
                      <tr key={p.id}>
                        <td style={{ fontWeight: 600 }}>{p.empresa}</td>
                        <td>{p.nome_cliente || '—'}</td>
                        <td><span className="badge badge-secondary">{p.tipo}</span></td>
                        <td style={{ fontWeight: 700, color: 'var(--primary)' }}>{formatBRL(p.valor_total)}</td>
                        <td><StatusBadge status={p.status} /></td>
                        <td style={{ fontSize: '.8rem' }}>{formatDate(p.data_hora)}</td>
                      </tr>
                    ))}
                    {!pedidos.length && (
                      <tr><td colSpan={6}><div className="empty-state"><Icon name="orders" /><h3>Nenhum pedido</h3></div></td></tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}
            <div className="table-footer">
              <span>Mostrando {pedidos.length} de {total}</span>
              <Pagination page={page} total={total} limit={20} onChange={setPage} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
